
/* NIR product-page bridge. Does not change the Cuspid UI. */
(function(){
  function openView(v){var b=document.querySelector('[data-a="go"][data-v="'+v+'"]');if(b)b.click();}
  var timer=null,views=['dashboard','calendar','flow','book','patients','practitioners','treatments','rooms','followups','billing','reminders','reports'],i=0;
  window.addEventListener('message',function(e){var d=e.data||{};if(!d.nir)return;
    if(d.type==='goto'&&d.view)openView(d.view);
    if(d.type==='tour'){openView('dashboard');setTimeout(function(){openView('calendar')},2200);setTimeout(function(){openView('book')},4400);setTimeout(function(){parent!==window&&parent.postMessage({nir:1,type:'tourEnd'},'*')},6600);}
    if(d.type==='cycle'){clearInterval(timer);timer=null;if(d.on){timer=setInterval(function(){i=(i+1)%views.length;openView(views[i])},3200);}}
  });
})();
